import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SunProgress } from "@/components/default/progress";
import { ChapterList } from "../chapterList/index";
import vueScroll from "vuescroll";

@Component({
    components: {
        SunProgress,
        vueScroll,
        ChapterList
    }
})
export default class ModuleList extends Vue {
    @Prop() readonly moduleList: any;
    private moduleListContent: any = {};
    private bColor: any = ["a0", "a1", "a2", "a3", "a4", "a5"];
    private currentModule: any = {};
    private currentChapterActive: false;
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(0, 0, 0, 0.4)"
        }
    };
    @Watch("moduleList")
    getchapterList(moduleList) {
        this.currentModule = moduleList[0];
        this.$set(this.currentModule, "moduleCollapse", true);
        this.$set(this.currentModule.children[0], "collapse", true);
        moduleList.forEach((moduleItem: any) => {
            moduleItem.children.forEach(chapterIem => {
                chapterIem.children[
                    chapterIem.children.length - 1
                ].children.forEach(sectionItem => {
                    if (
                        sectionItem.evaluateType === "PASS" &&
                        sectionItem.status !== "UNLEARNED"
                    ) {
                        this.$set(chapterIem, "ifKnow", "PASS");
                    }
                    if (
                        sectionItem.evaluateType === "NOPASS" &&
                        sectionItem.status !== "UNLEARNED"
                    ) {
                        this.$set(chapterIem, "ifKnow", "NOPASS");
                    }
                });
            });
            if (moduleItem.placeStatus) {
                this.$set(moduleItem, "moduleCollapse", true);
                this.currentModule = moduleItem;
            } else {
                this.$set(moduleItem, "moduleCollapse", false);
            }
            this.moduleListContent = moduleList;
        });
    }
    handleModuleClick(item) {
        let type = item.children[0].children[0].children[0].unlockType;
        let time = item.children[0].children[0].children[0].unlockTime;
        if (type === "FIXED_DAY" && time > Number(new Date())) {
            this.$set(item, "moduleCollapse", false);
            this.$message.warning("还没到开课时间");
        } else {
            this.currentModule = item;
            this.moduleList.forEach(moduleItem => {
                this.$set(moduleItem, "moduleCollapse", false);
            });
            this.$set(item, "moduleCollapse", true);
        }
    }
}
//@ts-ignore
export { default as ModuleList } from "./index.vue";
